import {User} from "../user.model";
import {GenericDgSearchResults} from "./generic.dg-search-results.model";

export class UsersDgSearchResults extends GenericDgSearchResults {
  public results: User[];

  constructor(total: number, results: User[], csrfToken: string, additionalCounter: number = null) {
    super();
    this.total = total;
    this.results = results;
    this.csrfToken = csrfToken;
    this.additionalCounter = additionalCounter;
  }
}
